import React from 'react';
import { default as RBRangeSlider } from 'react-bootstrap-range-slider';

export default class RangeSlider extends React.Component {
    render() {
        const { displayValue, ...otherProps } = this.props;
        return (
            <div>
                <div className="text-center">{displayValue}</div>
                <RBRangeSlider tooltip={'off'} {...otherProps} />
            </div>
        );
    }
}